import React, { useRef } from "react";

const InvoiceModal = ({ isOpen, htmlContent, onClose }) => {
  const iframeRef = useRef(null);

  if (!isOpen) return null;

  const handleDownloadPdf = () => {
    if (iframeRef.current && iframeRef.current.contentWindow) {
      // Focus on the iframe window and trigger the native browser print dialogue
      iframeRef.current.contentWindow.focus();
      iframeRef.current.contentWindow.print();
    }
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <div style={styles.header}>
          <div style={styles.headerTitleGroup}>
            <h3 style={{ margin: 0, fontSize: "16px", color: "#333" }}>Document Preview</h3>
            
            {/* Native Download/Print Action Button */}
            <button onClick={handleDownloadPdf} style={styles.downloadBtn} title="Download as PDF / Print">
              <svg style={{ width: "16px", height: "16px" }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
              </svg>
              <span>Download PDF</span>
            </button>
          </div>
          <button onClick={onClose} style={styles.closeBtn}>&times;</button>
        </div>
        <div style={styles.body}>
          <iframe
            ref={iframeRef}
            title="Invoice Document Frame"
            srcDoc={htmlContent}
            style={styles.iframe}
          />
        </div>
      </div>
    </div>
  );
};

const styles = {
  overlay: { position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(0,0,0,0.6)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000 },
  modal: { backgroundColor: "#fff", width: "90%", maxWidth: "700px", height: "85vh", borderRadius: "8px", display: "flex", flexDirection: "column", overflow: "hidden" },
  header: { display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 20px", borderBottom: "1px solid #eee", background: "#f8f9fa" },
  headerTitleGroup: { display: "flex", alignItems: "center", gap: "20px" },
  downloadBtn: { display: "flex", alignItems: "center", gap: "6px", backgroundColor: "#7B2CBF", color: "white", border: "none", padding: "6px 12px", fontSize: "12px", fontWeight: "600", borderRadius: "4px", cursor: "pointer", transition: "background-color 0.2s" },
  closeBtn: { background: "none", border: "none", fontSize: "24px", cursor: "pointer", color: "#333", padding: "0 5px" },
  body: { flex: 1, padding: "10px", backgroundColor: "#f4f6f9" },
  iframe: { width: "100%", height: "100%", border: "none", borderRadius: "4px", background: "#fff" }
};

export default InvoiceModal;